var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:_vm.className,attrs:{"alt":this.altText,"src":_vm.fullHref,"onerror":"this.src='https://www.liffery.com/img/icons/logo-128x128.png'"}})}
var staticRenderFns = []

export { render, staticRenderFns }